export const ERRORS = {
  LOAD_ERROR: "Error while loading reports",
  LOAD_ERROR_SINGLE_CASE: "Fetching single-case failed"
};

export default ERRORS;
